<template>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div class="shadow overflow-hidden sm:rounded-lg">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50" v-if="count > 0">
            <tr>
              <th
                v-for="(col, index) in columns"
                :key="col + index"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap text-uppercase"
              >
                {{ col }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="count == 0">
              <td
                :colspan="columns.length"
                class="bg-white px-6 py-4 whitespace-nowrap text-sm text-center font-medium text-gray-500"
              >
                <i class="fas fa-folder-open mr-1"></i>
                Aucun client trouver
              </td>
            </tr>
            <tr
              v-for="(item, index) in items"
              :key="`${item.id}-${index}`"
              class="bg-white"
              :class="{ 'bg-gray-50': index % 2 }"
            >
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ item.name }}
                <component
                  :is="item.vat ? 'a' : 'span'"
                  :href="getKBOLink(item)"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  class="block hover:text-indigo-500"
                >
                  {{ item.vat || '' }}
                </component>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <a :href="getGoogleLink(item)" target="_blank" class="block hover:text-indigo-500">
                  {{ item.street }} {{ item.housenumber }}<br />{{ item.zip }} {{ item.city }}, {{ item.country }}
                </a>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <a
                  v-if="item.email"
                  class="block hover:text-indigo-500"
                  :class="{ '-mt-1': !!item.phone }"
                  :href="`mailto:${item.email}`"
                >
                  <span>{{ item.email }}</span>
                </a>
                <a
                  v-if="item.phone"
                  class="block hover:text-indigo-500 text-sm"
                  :class="{ 'mt-2': !!item.email }"
                  :href="`tel:${item.phone.replace(/[^0-9+]+/gi, '')}`"
                >
                  <span>{{ item.phone }}</span>
                </a>
                <span v-if="!item.phone && !item.email">/</span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <router-link
                  :to="`/clients/${item.id}/edit`"
                  class="text-indigo-600 hover:text-indigo-900 w-12 inline-block"
                >
                  Modifier
                </router-link>
                <router-link
                  :to="`/clients/${item.id}`"
                  class="text-indigo-600 hover:text-indigo-900 w-12 inline-block"
                >
                  Voir
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="px-4 sm:px-6 md:px-8 -mt-1">
      <UIAtomPagination v-model="page" :offset="offset" :limit="limit" :count="count" />
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import useApi from '@/hooks/useApi'
import UIAtomPagination from '@/components/UI/Atom/Pagination'
import { useRoute } from 'vue-router'

export default {
  components: {
    UIAtomPagination,
  },
  setup() {
    const api = useApi()
    const route = useRoute()

    const page = ref(route.query.page > 0 ? Number(route.query.page) : 1)
    const count = ref(-1)
    const limit = ref(10)
    const items = ref([])
    const offset = computed(() => limit.value * (page.value - 1))

    const refresh = () => {
      api.clients.list({ limit: limit.value, offset: offset.value }).then(({ data }) => {
        if (data.count || count.value === -1) count.value = data.count
        if (data.list && data.list.length) items.value = data.list
      })
    }
    refresh()
    watch(() => page.value, refresh)

    const getGoogleLink = item =>
      `https://www.google.com/maps/dir//${encodeURIComponent(
        [item.street, item.housenumber, item.zip, item.city, item.country].filter(el => !!el).join('+'),
      )}`

    const getKBOLink = item => {
      if (!item.vat) return undefined
      const nr = item.vat.replace(/\D/gi, '')
      return `https://kbopub.economie.fgov.be/kbopub/toonvestigingps.html?lang=fr&ondernemingsnummer=${nr}`
    }

    const columns = ['Client', 'Adresse', 'Mail/Tel', '']
    return { columns, page, limit, offset, count, items, getGoogleLink, getKBOLink }
  },
}
</script>

<style></style>
